export const UnsubscribeScope = {
	all: 'All',
	recommendations: 'Recommendations',
};

export const UnsubscribeEventType = {
	subscribe: 'Subscribe',
	unsubscribe: 'Unsubscribe',
};
